// extracted by mini-css-extract-plugin
export var actionButton = "_fe-0";
export var fileInput = "_fe-2";
export var paperclip = "_fe-1";